import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import 'react-id-swiper/lib/styles/css/swiper.css';

import { getProducts, getFlashMessage } from '../../store/selectors';
import { doRequestSubscription, doFetchSubscription, doSetFlashMessage } from '../../store/actions';
import Header from '../../components/Header';
import { Title, Subtitle } from '../../components/Title';
import { ProductsBody, ProductsWrapper } from '../../components/Products/ProductsComponents';
import { postMessageSender } from '../../lib/postMessager';
import ProductsList from '../../components/Products/ProductsList';
import Advantages from '../../components/Advantages';
import flashMessageTypes from '../../constants/flashMessageTypes';
import { ContentWrapper } from '../../lib/global-styles';
import Checkout from '../../components/Checkout';
import ComboGroups from '../../components/ComboGroups';
import messages from '../../constants/messages';

class Products extends Component {
  state = {
    selectedProduct: null,
    card: {
      cvv: '',
      number: '',
      validity: '',
    },
    error: {
      number: '',
      validity: '',
      cvv: '',
    },
    selectedColor: null,
    checkoutOpen: false,
  };

  onProductClick = (e, product, color) => {
    e.preventDefault();

    this.setState({
      selectedProduct: product,
      selectedColor: color,
      checkoutOpen: true,
    });

    console.log(product);

    postMessageSender({
      action: 'productSelected',
      product: {
        id: product.id,
        name: product.groupName,
      },
      scrollTop: true,
    });
  };

  onCloseCheckout = (e, isFromCloseButton = false) => {
    e.preventDefault();
    const { flashMessage, onFetchSubscription, onSetFlashMessage } = this.props;

    if (e.target === e.currentTarget || isFromCloseButton) {
      if (flashMessage.type === flashMessageTypes.success) {
        onSetFlashMessage(null);
        onFetchSubscription();
      }

      this.setState({
        checkoutOpen: false,
      });
    }
  };

  render() {
    const { products } = this.props;
    const { selectedProduct, checkoutOpen, selectedColor } = this.state;

    const basicProducts = products.filter(product => !product.isCombo);

    return (
      <ContentWrapper>
        <Header secondary={false} />

        <ProductsBody>
          <ProductsWrapper>
            <Advantages />
            <Title>{messages.phraseology.welcome.title.subscribe}</Title>
            <Subtitle>{messages.phraseology.welcome.description.subscribe}</Subtitle>
            <form>
              <ProductsList
                products={basicProducts}
                selectedProduct={selectedProduct}
                onProductClick={this.onProductClick}
              />

              {selectedProduct && checkoutOpen ? (
                <Checkout
                  onCloseCheckout={this.onCloseCheckout}
                  checkoutOpen={checkoutOpen}
                  selectedProduct={selectedProduct}
                  selectedColor={selectedColor}
                />
              ) : null}
            </form>
            <ComboGroups products={products} />
          </ProductsWrapper>
        </ProductsBody>
      </ContentWrapper>
    );
  }
}

Products.propTypes = {
  products: PropTypes.array,
  flashMessage: PropTypes.object,
  onRequestSubscription: PropTypes.func.isRequired,
  onFetchSubscription: PropTypes.func,
  onSetFlashMessage: PropTypes.func,
};

const mapStateToProps = state => ({
  products: getProducts(state),
  flashMessage: getFlashMessage(state),
});

const mapDispatchToProps = dispatch => ({
  onRequestSubscription: payload => dispatch(doRequestSubscription(payload)),
  onFetchSubscription: () => dispatch(doFetchSubscription()),
  onSetFlashMessage: payload => dispatch(doSetFlashMessage(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Products);
